module.exports = __webpack_public_path__ + "static/media/comingsoon.00979f60.png";